import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StudentDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type StudentDeleteMutation = { __typename?: 'Mutation', studentDelete: { __typename?: 'StudentPayload', recordId: string, record: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, errors?: Array<{ __typename?: 'StudentDoesNotExistsProblem', message: string } | { __typename?: 'StudentExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'StudentSaveProblem', message: string } | { __typename?: 'StudentUpdateProblem', message: string }> | null } };

export type StudentPublishUpdateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type StudentPublishUpdateMutation = { __typename?: 'Mutation', studentPublishUpdate: { __typename?: 'StudentPayload', recordId: string, record: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, errors?: Array<{ __typename?: 'StudentDoesNotExistsProblem', message: string } | { __typename?: 'StudentExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'StudentSaveProblem', message: string } | { __typename?: 'StudentUpdateProblem', message: string }> | null } };

export type StudentSaveMutationVariables = Types.Exact<{
  studentInput: Types.StudentInput;
}>;


export type StudentSaveMutation = { __typename?: 'Mutation', studentSave: { __typename?: 'StudentPayload', recordId: string, record: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, errors?: Array<{ __typename?: 'StudentDoesNotExistsProblem', message: string } | { __typename?: 'StudentExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'StudentSaveProblem', message: string } | { __typename?: 'StudentUpdateProblem', message: string }> | null } };

export type StudentUpdateMutationVariables = Types.Exact<{
  studentInput: Types.StudentInputWithId;
}>;


export type StudentUpdateMutation = { __typename?: 'Mutation', studentUpdate: { __typename?: 'StudentPayload', recordId: string, record: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, errors?: Array<{ __typename?: 'StudentDoesNotExistsProblem', message: string } | { __typename?: 'StudentExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'StudentSaveProblem', message: string } | { __typename?: 'StudentUpdateProblem', message: string }> | null } };

export type NearestStudentBirthdaysQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type NearestStudentBirthdaysQuery = { __typename?: 'Query', nearestStudentBirthdays?: Array<{ __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }> | null };

export type StudentQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type StudentQuery = { __typename?: 'Query', student?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null } | null };

export type StudentAllQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type StudentAllQuery = { __typename?: 'Query', studentAll?: Array<{ __typename?: 'StudentDto', value: string, label: string }> | null };

export type StudentsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['ID']>;
  before?: Types.InputMaybe<Types.Scalars['ID']>;
  filter?: Types.InputMaybe<Types.StudentFilter>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type StudentsQuery = { __typename?: 'Query', students?: { __typename?: 'StudentConnection', edges: Array<{ __typename?: 'StudentEdge', cursor: string, node?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null } | null }>, pageInfo?: { __typename?: 'PageInfo', endCursor: string, hasNextPage?: boolean | null, startCursor: string } | null } | null };

export type StudentsByTeamQueryVariables = Types.Exact<{
  team: Types.Scalars['ID'];
}>;


export type StudentsByTeamQuery = { __typename?: 'Query', studentsByTeam?: Array<{ __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }> | null };

export type StudentByCreatorQueryVariables = Types.Exact<{
  creator: Types.Scalars['ID'];
}>;


export type StudentByCreatorQuery = { __typename?: 'Query', studentByCreator?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null } | null };

export type UnPayedStudentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UnPayedStudentsQuery = { __typename?: 'Query', unPayedStudents?: Array<{ __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }> | null };

export type NearestHeadCoachStudentBirthdaysQueryVariables = Types.Exact<{
  before: Types.Scalars['Int'];
  after: Types.Scalars['Int'];
}>;


export type NearestHeadCoachStudentBirthdaysQuery = { __typename?: 'Query', nearestHeadCoachStudentBirthdays?: Array<{ __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }> | null };


export const StudentDeleteDocument = gql`
    mutation studentDelete($id: ID!) {
  studentDelete(id: $id) {
    record {
      birthday
      creatorIds
      creators {
        id
        name
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        cardDetails
      }
      id
      fileName
      name
      passportNum
      paymentSum
      published
      teamIds
      teams {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        headCoachPayment
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      address
      description
      school
      lastVisits
    }
    recordId
    errors {
      ... on StudentDoesNotExistsProblem {
        message
      }
      ... on StudentExistInOtherComponentsProblem {
        component
        message
      }
      ... on StudentSaveProblem {
        message
      }
      ... on StudentUpdateProblem {
        message
      }
    }
  }
}
    `;
export type StudentDeleteMutationFn = Apollo.MutationFunction<StudentDeleteMutation, StudentDeleteMutationVariables>;

/**
 * __useStudentDeleteMutation__
 *
 * To run a mutation, you first call `useStudentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentDeleteMutation, { data, loading, error }] = useStudentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<StudentDeleteMutation, StudentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentDeleteMutation, StudentDeleteMutationVariables>(StudentDeleteDocument, options);
      }
export type StudentDeleteMutationHookResult = ReturnType<typeof useStudentDeleteMutation>;
export type StudentDeleteMutationResult = Apollo.MutationResult<StudentDeleteMutation>;
export type StudentDeleteMutationOptions = Apollo.BaseMutationOptions<StudentDeleteMutation, StudentDeleteMutationVariables>;
export const StudentPublishUpdateDocument = gql`
    mutation studentPublishUpdate($id: ID!) {
  studentPublishUpdate(id: $id) {
    record {
      birthday
      creatorIds
      creators {
        id
        name
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        cardDetails
      }
      id
      fileName
      name
      passportNum
      paymentSum
      published
      teamIds
      teams {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        headCoachPayment
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      address
      description
      school
      lastVisits
    }
    recordId
    errors {
      ... on StudentDoesNotExistsProblem {
        message
      }
      ... on StudentExistInOtherComponentsProblem {
        component
        message
      }
      ... on StudentSaveProblem {
        message
      }
      ... on StudentUpdateProblem {
        message
      }
    }
  }
}
    `;
export type StudentPublishUpdateMutationFn = Apollo.MutationFunction<StudentPublishUpdateMutation, StudentPublishUpdateMutationVariables>;

/**
 * __useStudentPublishUpdateMutation__
 *
 * To run a mutation, you first call `useStudentPublishUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentPublishUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentPublishUpdateMutation, { data, loading, error }] = useStudentPublishUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentPublishUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StudentPublishUpdateMutation, StudentPublishUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentPublishUpdateMutation, StudentPublishUpdateMutationVariables>(StudentPublishUpdateDocument, options);
      }
export type StudentPublishUpdateMutationHookResult = ReturnType<typeof useStudentPublishUpdateMutation>;
export type StudentPublishUpdateMutationResult = Apollo.MutationResult<StudentPublishUpdateMutation>;
export type StudentPublishUpdateMutationOptions = Apollo.BaseMutationOptions<StudentPublishUpdateMutation, StudentPublishUpdateMutationVariables>;
export const StudentSaveDocument = gql`
    mutation studentSave($studentInput: StudentInput!) {
  studentSave(studentInput: $studentInput) {
    record {
      birthday
      creatorIds
      creators {
        id
        name
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        cardDetails
      }
      id
      fileName
      name
      passportNum
      paymentSum
      published
      teamIds
      teams {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        headCoachPayment
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      address
      description
      school
      lastVisits
    }
    recordId
    errors {
      ... on StudentDoesNotExistsProblem {
        message
      }
      ... on StudentExistInOtherComponentsProblem {
        component
        message
      }
      ... on StudentSaveProblem {
        message
      }
      ... on StudentUpdateProblem {
        message
      }
    }
  }
}
    `;
export type StudentSaveMutationFn = Apollo.MutationFunction<StudentSaveMutation, StudentSaveMutationVariables>;

/**
 * __useStudentSaveMutation__
 *
 * To run a mutation, you first call `useStudentSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentSaveMutation, { data, loading, error }] = useStudentSaveMutation({
 *   variables: {
 *      studentInput: // value for 'studentInput'
 *   },
 * });
 */
export function useStudentSaveMutation(baseOptions?: Apollo.MutationHookOptions<StudentSaveMutation, StudentSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentSaveMutation, StudentSaveMutationVariables>(StudentSaveDocument, options);
      }
export type StudentSaveMutationHookResult = ReturnType<typeof useStudentSaveMutation>;
export type StudentSaveMutationResult = Apollo.MutationResult<StudentSaveMutation>;
export type StudentSaveMutationOptions = Apollo.BaseMutationOptions<StudentSaveMutation, StudentSaveMutationVariables>;
export const StudentUpdateDocument = gql`
    mutation studentUpdate($studentInput: StudentInputWithId!) {
  studentUpdate(studentInput: $studentInput) {
    record {
      birthday
      creatorIds
      creators {
        id
        name
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        cardDetails
      }
      id
      fileName
      name
      passportNum
      paymentSum
      published
      teamIds
      teams {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        headCoachPayment
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      address
      description
      school
      lastVisits
    }
    recordId
    errors {
      ... on StudentDoesNotExistsProblem {
        message
      }
      ... on StudentExistInOtherComponentsProblem {
        component
        message
      }
      ... on StudentSaveProblem {
        message
      }
      ... on StudentUpdateProblem {
        message
      }
    }
  }
}
    `;
export type StudentUpdateMutationFn = Apollo.MutationFunction<StudentUpdateMutation, StudentUpdateMutationVariables>;

/**
 * __useStudentUpdateMutation__
 *
 * To run a mutation, you first call `useStudentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentUpdateMutation, { data, loading, error }] = useStudentUpdateMutation({
 *   variables: {
 *      studentInput: // value for 'studentInput'
 *   },
 * });
 */
export function useStudentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StudentUpdateMutation, StudentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentUpdateMutation, StudentUpdateMutationVariables>(StudentUpdateDocument, options);
      }
export type StudentUpdateMutationHookResult = ReturnType<typeof useStudentUpdateMutation>;
export type StudentUpdateMutationResult = Apollo.MutationResult<StudentUpdateMutation>;
export type StudentUpdateMutationOptions = Apollo.BaseMutationOptions<StudentUpdateMutation, StudentUpdateMutationVariables>;
export const NearestStudentBirthdaysDocument = gql`
    query nearestStudentBirthdays {
  nearestStudentBirthdays {
    birthday
    creatorIds
    creators {
      id
      name
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      cardDetails
    }
    id
    fileName
    name
    passportNum
    paymentSum
    published
    teamIds
    teams {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      headCoachPayment
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    address
    description
    school
    lastVisits
  }
}
    `;

/**
 * __useNearestStudentBirthdaysQuery__
 *
 * To run a query within a React component, call `useNearestStudentBirthdaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useNearestStudentBirthdaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNearestStudentBirthdaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useNearestStudentBirthdaysQuery(baseOptions?: Apollo.QueryHookOptions<NearestStudentBirthdaysQuery, NearestStudentBirthdaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NearestStudentBirthdaysQuery, NearestStudentBirthdaysQueryVariables>(NearestStudentBirthdaysDocument, options);
      }
export function useNearestStudentBirthdaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NearestStudentBirthdaysQuery, NearestStudentBirthdaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NearestStudentBirthdaysQuery, NearestStudentBirthdaysQueryVariables>(NearestStudentBirthdaysDocument, options);
        }
export type NearestStudentBirthdaysQueryHookResult = ReturnType<typeof useNearestStudentBirthdaysQuery>;
export type NearestStudentBirthdaysLazyQueryHookResult = ReturnType<typeof useNearestStudentBirthdaysLazyQuery>;
export type NearestStudentBirthdaysQueryResult = Apollo.QueryResult<NearestStudentBirthdaysQuery, NearestStudentBirthdaysQueryVariables>;
export function refetchNearestStudentBirthdaysQuery(variables?: NearestStudentBirthdaysQueryVariables) {
      return { query: NearestStudentBirthdaysDocument, variables: variables }
    }
export const StudentDocument = gql`
    query student($id: ID!) {
  student(id: $id) {
    birthday
    creatorIds
    creators {
      id
      name
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      cardDetails
    }
    id
    fileName
    name
    passportNum
    paymentSum
    published
    teamIds
    teams {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      headCoachPayment
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    address
    description
    school
    lastVisits
  }
}
    `;

/**
 * __useStudentQuery__
 *
 * To run a query within a React component, call `useStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentQuery(baseOptions: Apollo.QueryHookOptions<StudentQuery, StudentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentQuery, StudentQueryVariables>(StudentDocument, options);
      }
export function useStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentQuery, StudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentQuery, StudentQueryVariables>(StudentDocument, options);
        }
export type StudentQueryHookResult = ReturnType<typeof useStudentQuery>;
export type StudentLazyQueryHookResult = ReturnType<typeof useStudentLazyQuery>;
export type StudentQueryResult = Apollo.QueryResult<StudentQuery, StudentQueryVariables>;
export function refetchStudentQuery(variables: StudentQueryVariables) {
      return { query: StudentDocument, variables: variables }
    }
export const StudentAllDocument = gql`
    query studentAll {
  studentAll {
    value
    label
  }
}
    `;

/**
 * __useStudentAllQuery__
 *
 * To run a query within a React component, call `useStudentAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentAllQuery(baseOptions?: Apollo.QueryHookOptions<StudentAllQuery, StudentAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentAllQuery, StudentAllQueryVariables>(StudentAllDocument, options);
      }
export function useStudentAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentAllQuery, StudentAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentAllQuery, StudentAllQueryVariables>(StudentAllDocument, options);
        }
export type StudentAllQueryHookResult = ReturnType<typeof useStudentAllQuery>;
export type StudentAllLazyQueryHookResult = ReturnType<typeof useStudentAllLazyQuery>;
export type StudentAllQueryResult = Apollo.QueryResult<StudentAllQuery, StudentAllQueryVariables>;
export function refetchStudentAllQuery(variables?: StudentAllQueryVariables) {
      return { query: StudentAllDocument, variables: variables }
    }
export const StudentsDocument = gql`
    query students($after: ID, $before: ID, $filter: StudentFilter, $first: Int, $last: Int) {
  students(
    after: $after
    before: $before
    filter: $filter
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          cardDetails
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          headCoachPayment
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        address
        description
        school
        lastVisits
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      startCursor
    }
  }
}
    `;

/**
 * __useStudentsQuery__
 *
 * To run a query within a React component, call `useStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useStudentsQuery(baseOptions?: Apollo.QueryHookOptions<StudentsQuery, StudentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentsQuery, StudentsQueryVariables>(StudentsDocument, options);
      }
export function useStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentsQuery, StudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentsQuery, StudentsQueryVariables>(StudentsDocument, options);
        }
export type StudentsQueryHookResult = ReturnType<typeof useStudentsQuery>;
export type StudentsLazyQueryHookResult = ReturnType<typeof useStudentsLazyQuery>;
export type StudentsQueryResult = Apollo.QueryResult<StudentsQuery, StudentsQueryVariables>;
export function refetchStudentsQuery(variables?: StudentsQueryVariables) {
      return { query: StudentsDocument, variables: variables }
    }
export const StudentsByTeamDocument = gql`
    query studentsByTeam($team: ID!) {
  studentsByTeam(team: $team) {
    birthday
    creatorIds
    creators {
      id
      name
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      cardDetails
    }
    id
    fileName
    name
    passportNum
    paymentSum
    published
    teamIds
    teams {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      headCoachPayment
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    address
    description
    school
    lastVisits
  }
}
    `;

/**
 * __useStudentsByTeamQuery__
 *
 * To run a query within a React component, call `useStudentsByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsByTeamQuery({
 *   variables: {
 *      team: // value for 'team'
 *   },
 * });
 */
export function useStudentsByTeamQuery(baseOptions: Apollo.QueryHookOptions<StudentsByTeamQuery, StudentsByTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentsByTeamQuery, StudentsByTeamQueryVariables>(StudentsByTeamDocument, options);
      }
export function useStudentsByTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentsByTeamQuery, StudentsByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentsByTeamQuery, StudentsByTeamQueryVariables>(StudentsByTeamDocument, options);
        }
export type StudentsByTeamQueryHookResult = ReturnType<typeof useStudentsByTeamQuery>;
export type StudentsByTeamLazyQueryHookResult = ReturnType<typeof useStudentsByTeamLazyQuery>;
export type StudentsByTeamQueryResult = Apollo.QueryResult<StudentsByTeamQuery, StudentsByTeamQueryVariables>;
export function refetchStudentsByTeamQuery(variables: StudentsByTeamQueryVariables) {
      return { query: StudentsByTeamDocument, variables: variables }
    }
export const StudentByCreatorDocument = gql`
    query studentByCreator($creator: ID!) {
  studentByCreator(creator: $creator) {
    birthday
    creatorIds
    creators {
      id
      name
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      cardDetails
    }
    id
    fileName
    name
    passportNum
    paymentSum
    published
    teamIds
    teams {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      headCoachPayment
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    address
    description
    school
    lastVisits
  }
}
    `;

/**
 * __useStudentByCreatorQuery__
 *
 * To run a query within a React component, call `useStudentByCreatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentByCreatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentByCreatorQuery({
 *   variables: {
 *      creator: // value for 'creator'
 *   },
 * });
 */
export function useStudentByCreatorQuery(baseOptions: Apollo.QueryHookOptions<StudentByCreatorQuery, StudentByCreatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentByCreatorQuery, StudentByCreatorQueryVariables>(StudentByCreatorDocument, options);
      }
export function useStudentByCreatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentByCreatorQuery, StudentByCreatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentByCreatorQuery, StudentByCreatorQueryVariables>(StudentByCreatorDocument, options);
        }
export type StudentByCreatorQueryHookResult = ReturnType<typeof useStudentByCreatorQuery>;
export type StudentByCreatorLazyQueryHookResult = ReturnType<typeof useStudentByCreatorLazyQuery>;
export type StudentByCreatorQueryResult = Apollo.QueryResult<StudentByCreatorQuery, StudentByCreatorQueryVariables>;
export function refetchStudentByCreatorQuery(variables: StudentByCreatorQueryVariables) {
      return { query: StudentByCreatorDocument, variables: variables }
    }
export const UnPayedStudentsDocument = gql`
    query unPayedStudents {
  unPayedStudents {
    birthday
    creatorIds
    creators {
      id
      name
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      cardDetails
    }
    id
    fileName
    name
    passportNum
    paymentSum
    published
    teamIds
    teams {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      headCoachPayment
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    address
    description
    school
    lastVisits
  }
}
    `;

/**
 * __useUnPayedStudentsQuery__
 *
 * To run a query within a React component, call `useUnPayedStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnPayedStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnPayedStudentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnPayedStudentsQuery(baseOptions?: Apollo.QueryHookOptions<UnPayedStudentsQuery, UnPayedStudentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnPayedStudentsQuery, UnPayedStudentsQueryVariables>(UnPayedStudentsDocument, options);
      }
export function useUnPayedStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnPayedStudentsQuery, UnPayedStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnPayedStudentsQuery, UnPayedStudentsQueryVariables>(UnPayedStudentsDocument, options);
        }
export type UnPayedStudentsQueryHookResult = ReturnType<typeof useUnPayedStudentsQuery>;
export type UnPayedStudentsLazyQueryHookResult = ReturnType<typeof useUnPayedStudentsLazyQuery>;
export type UnPayedStudentsQueryResult = Apollo.QueryResult<UnPayedStudentsQuery, UnPayedStudentsQueryVariables>;
export function refetchUnPayedStudentsQuery(variables?: UnPayedStudentsQueryVariables) {
      return { query: UnPayedStudentsDocument, variables: variables }
    }
export const NearestHeadCoachStudentBirthdaysDocument = gql`
    query nearestHeadCoachStudentBirthdays($before: Int!, $after: Int!) {
  nearestHeadCoachStudentBirthdays(before: $before, after: $after) {
    birthday
    creatorIds
    creators {
      id
      name
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      cardDetails
    }
    id
    fileName
    name
    passportNum
    paymentSum
    published
    teamIds
    teams {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      headCoachPayment
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    address
    description
    school
    lastVisits
  }
}
    `;

/**
 * __useNearestHeadCoachStudentBirthdaysQuery__
 *
 * To run a query within a React component, call `useNearestHeadCoachStudentBirthdaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useNearestHeadCoachStudentBirthdaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNearestHeadCoachStudentBirthdaysQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useNearestHeadCoachStudentBirthdaysQuery(baseOptions: Apollo.QueryHookOptions<NearestHeadCoachStudentBirthdaysQuery, NearestHeadCoachStudentBirthdaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NearestHeadCoachStudentBirthdaysQuery, NearestHeadCoachStudentBirthdaysQueryVariables>(NearestHeadCoachStudentBirthdaysDocument, options);
      }
export function useNearestHeadCoachStudentBirthdaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NearestHeadCoachStudentBirthdaysQuery, NearestHeadCoachStudentBirthdaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NearestHeadCoachStudentBirthdaysQuery, NearestHeadCoachStudentBirthdaysQueryVariables>(NearestHeadCoachStudentBirthdaysDocument, options);
        }
export type NearestHeadCoachStudentBirthdaysQueryHookResult = ReturnType<typeof useNearestHeadCoachStudentBirthdaysQuery>;
export type NearestHeadCoachStudentBirthdaysLazyQueryHookResult = ReturnType<typeof useNearestHeadCoachStudentBirthdaysLazyQuery>;
export type NearestHeadCoachStudentBirthdaysQueryResult = Apollo.QueryResult<NearestHeadCoachStudentBirthdaysQuery, NearestHeadCoachStudentBirthdaysQueryVariables>;
export function refetchNearestHeadCoachStudentBirthdaysQuery(variables: NearestHeadCoachStudentBirthdaysQueryVariables) {
      return { query: NearestHeadCoachStudentBirthdaysDocument, variables: variables }
    }